import React from 'react';
import { Grid, Table, Modal, Button} from 'semantic-ui-react';
import QueryTab from "./query-tab"
import FormattedDate from "../../components/formatters/formattedDate";

import {NoData} from "../../components/table/no-data";

export default class CaseTableRow extends React.Component {


  render() {
    return (
      <Table.Row>
        <Table.Cell>{this.props.data.queryKey || <NoData/>}</Table.Cell>
        <Table.Cell>{this.props.data.status || <NoData/>}</Table.Cell>
        <Table.Cell>{this.props.data.queryType || <NoData/>}</Table.Cell>
        <Table.Cell>{this.props.data.caseCategory || <NoData/>}</Table.Cell>

        <Table.Cell>{this.props.data.description || <NoData/>}</Table.Cell>
        <Table.Cell><FormattedDate inputFormat="YYYY-MM-DDThh:mm:ss" value={this.props.data.dateLogged}/></Table.Cell>
        
        <Table.Cell>
          {this.props.data.dateCompleted !== '0001-01-01T00:00:00' ? (
            <FormattedDate
              inputFormat="YYYY-MM-DDThh:mm:ss"
              value={this.props.data.dateCompleted}
            />
          ) : (
            'N/A'
          )}
        </Table.Cell>

        
        <Table.Cell>
          <Modal size="large" trigger={<Button basic >Case Detail</Button>} centered={false} closeIcon>
            <Modal.Header>
              <h3>Subject: {this.props.data.description}</h3>
              <h4>Case ID: {this.props.data.queryKey}</h4>
            </Modal.Header>
            <Modal.Content >
              <Grid padded stackable columns='equal' verticalAlign='middle'>
                <Grid.Row>
                  <Grid.Column>
                    {this.props.data.status && <QueryTab data={this.props.data} status={this.props.data.status} />}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Modal.Content>
          </Modal>
        </Table.Cell>
      </Table.Row>
    );
  }
}